import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import memoirReducer from './slices/memoirSlice';
import chapterReducer from './slices/chapterSlice';
import uiReducer from './slices/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    memoir: memoirReducer,
    chapter: chapterReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;